import { db } from "../Config";

// Verifica si la empresa tiene horarios de especialistas configurados
export const tieneHorariosConfigurados = async (empresaId) => {
  try {
    const snapshot = await db
      .collection("empresas").doc(empresaId).collection("horarios_especialistas")
      .limit(1)
      .get();
    return !snapshot.empty;
  } catch (error) {
    console.error("Error al verificar horarios de especialistas:", error);
    throw error;
  }
};


// Agrega un nuevo horario de especialista
export const addHorarioEspecialista = (idEmpresa, horarioData) => {
  return async function (dispatch, getState) {
    try {
      if (!horarioData.especialistaId) throw new Error("especialistaId es requerido");

      // Agregar el nuevo horario
      const nuevoHorario = {
        ...horarioData,
        empresaId: idEmpresa,
        createdAt: new Date(),  // Fecha local como respaldo
        updatedAt: new Date(),  // Fecha local como respaldo
        duracionCitaMin: parseInt(horarioData.duracionCitaMin) || 30,
      };

      // Usar especialistaId como el ID del documento
      const docRef = db.collection("empresas").doc(idEmpresa).collection("horarios_especialistas").doc(horarioData.especialistaId);
      await docRef.set(nuevoHorario);

      return docRef.id;
    } catch (error) {
      console.error("Error al guardar horario de especialista:", error);
      throw error;
    }
  };
};

// Obtiene los horarios por empresa
export const fetchHorariosByEmpresa = async (empresaId) => {
  try {
    const snapshot = await db
      .collection("empresas").doc(empresaId).collection("horarios_especialistas")
      .get();

    let horarios = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Ordenar los resultados en JavaScript después de obtenerlos
    horarios.sort((a, b) => {
      // Asegurarse de que sean objetos Date para comparación correcta
      const dateA = a.createdAt instanceof Date ? a.createdAt : new Date(a.createdAt);
      const dateB = b.createdAt instanceof Date ? b.createdAt : new Date(b.createdAt);
      return dateB - dateA; // Orden descendente
    });

    return horarios;
  } catch (error) {
    console.error("Error al obtener horarios de especialistas:", error);
    throw error;
  }
};



// Elimina un horario de especialista
export const deleteHorarioEspecialista = (id, idEmpresa) => {
  return async (dispatch) => {
    try {
      // 1. Validación básica de los parámetros
      if (!id || typeof id !== "string") {
        throw new Error("ID de horario inválido");
      }
      if (!idEmpresa || typeof idEmpresa !== "string") {
        throw new Error("ID de empresa inválido");
      }

      // 2. Obtener referencia al documento
      const docRef = db.collection("empresas").doc(idEmpresa).collection("horarios_especialistas").doc(id);

      // 3. Verificar existencia del documento
      const docSnapshot = await docRef.get();
      if (!docSnapshot.exists) {
        throw new Error("El horario de especialista no existe en la base de datos");
      }

      // 4. Verificar que el empresaId coincida con idEmpresa
      // (Redundant check if we are already in the subcollection, but good for sanity)
      // const horarioData = docSnapshot.data();
      // if (horarioData.empresaId !== idEmpresa) {
      //   throw new Error("No se puede eliminar este horario porque no pertenece a la empresa especificada");
      // }

      // 5. Ejecutar la eliminación
      await docRef.delete();

      // 6. Actualizar el estado global
      dispatch({
        type: 'HORARIO_ESPECIALISTA_DELETED',
        payload: id
      });

      // 7. Retornar el ID para posibles usos posteriores
      return id;

    } catch (error) {
      console.error("Error en deleteHorarioEspecialista:", error);
      throw error; // Propagar el error para manejo superior
    }
  };
};

// Guarda o actualiza un horario de especialista usando el ID específico
export const updateHorarioEmpresa = async (horarioId, horarioData) => {
  try {
    if (!horarioData.empresaId) throw new Error("empresaId es requerido para actualizar");

    const horarioRef = db.collection("empresas").doc(horarioData.empresaId).collection("horarios_especialistas").doc(horarioId);
    //const doc = await horarioRef.get();

    //if (doc.exists) {
    // Actualizar si ya existe
    await horarioRef.update({
      ...horarioData,
    });
    //} 

    return true;
  } catch (err) {
    throw err;
  }
};

// Guarda o actualiza un horario de especialista usando el ID específico
export const addHorarioEmpresa = async (horarioData) => {
  try {
    if (!horarioData.empresaId) {
      throw new Error("empresaId es requerido para crear horario");
    }
    if (!horarioData.especialistaId) {
      throw new Error("especialistaId es requerido para crear horario");
    }

    // Usar especialistaId como el ID del documento
    const horarioRef = db.collection("empresas").doc(horarioData.empresaId).collection("horarios_especialistas").doc(horarioData.especialistaId);

    // Crear o sobrescribir registro
    await horarioRef.set({
      ...horarioData,
    });

    return horarioRef.id;
  } catch (err) {
    throw err;
  }
};
export const getHorariosByEspecialistaAndByEmpresa = async (especialistaId, empresaId) => {
  try {
    // Intentamos obtener el documento directamente usando el especialistaId como ID
    const docRef = db
      .collection("empresas").doc(empresaId).collection("horarios_especialistas")
      .doc(especialistaId);
    
    const docSnapshot = await docRef.get();

    if (docSnapshot.exists) {
      return {
        id: docSnapshot.id,
        ...docSnapshot.data()
      };
    } else {
      // Si no existe el documento con el ID del especialista, 
      // verificamos si existe alguno con el campo especialistaId (migración o casos antiguos)
      const querySnapshot = await db
        .collection("empresas").doc(empresaId).collection("horarios_especialistas")
        .where("especialistaId", "==", especialistaId)
        .limit(1)
        .get();

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        return {
          id: doc.id,
          ...doc.data()
        };
      }

      // Si no existe, buscamos el horario por defecto
      const defaultHorarioRef = db.collection("configuraciones_generales").doc("horarios_especialistas");
      const defaultDoc = await defaultHorarioRef.get();

      if (defaultDoc.exists) {
        return {
          id: defaultDoc.id,
          ...defaultDoc.data()
        };
      }

      return null;
    }

  } catch (error) {
    throw new Error(`Error al obtener horario: ${error.message}`);
  }
};